import { getUserInfo, setUserInfo, clearUserInfo } from '@/helper/loginStatusManger';

export const saveOpenid = oid => {
  if (typeof window === 'undefined') {
    return;
  }
  const userInfo = getUserInfo() || {};
  userInfo.openid = oid;
  setUserInfo(userInfo);
};

export const getOpenid = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const userInfo = getUserInfo() || {};
  return userInfo.openid;
};

export const clearOpenid = () => {
  if (typeof window === 'undefined') {
    return;
  }
  clearUserInfo();
};
